/**
 * Carousel.
 *
 * Native scroll-snap does the scrolling and the swipe; this only drives the
 * buttons, the dots and the snapped-slide state. Hooks: data-carousel on the
 * wrapper, data-carousel-prev/-next, and data-carousel-dot="N", 1-indexed.
 */
(function() {
    'use strict';

    function initCarousel(carousel) {
        var scrollContainer = carousel.querySelector('.carousel');
        var slides = carousel.querySelectorAll('.carousel-slide');
        var prevBtn = carousel.querySelector('[data-carousel-prev]');
        var nextBtn = carousel.querySelector('[data-carousel-next]');
        var dots = carousel.querySelectorAll('[data-carousel-dot]');

        if (!scrollContainer || slides.length === 0) return;

        var currentIndex = 0;
        var totalSlides = slides.length;

        function updateDots() {
            dots.forEach(function(dot, i) {
                dot.classList.toggle('active', i === currentIndex);
            });
        }

        function updateSnapped() {
            slides.forEach(function(slide, i) {
                slide.classList.toggle('is-snapped', i === currentIndex);
            });
        }

        function goToSlide(index) {
            if (index < 0) index = totalSlides - 1;
            if (index >= totalSlides) index = 0;

            // Determine if we're wrapping (jumping more than 1 slide)
            var needsWrap = Math.abs(index - currentIndex) > 1;

            currentIndex = index;

            // Use instant scroll for wrap-around, smooth for adjacent slides
            scrollToSlide(currentIndex, needsWrap ? 'auto' : 'smooth');

            updateDots();
            updateSnapped();
        }

        function nextSlide() {
            goToSlide(currentIndex + 1);
        }

        function prevSlide() {
            goToSlide(currentIndex - 1);
        }

        // Find the slide closest to the center of the scroll container
        function findCenteredSlide() {
            var containerCenter = scrollContainer.scrollLeft + scrollContainer.clientWidth / 2;
            var closestIndex = 0;
            var closestDistance = Infinity;
            slides.forEach(function(slide, i) {
                var slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
                var distance = Math.abs(slideCenter - containerCenter);
                if (distance < closestDistance) {
                    closestDistance = distance;
                    closestIndex = i;
                }
            });
            return closestIndex;
        }

        // Scroll a slide to center within the carousel (without affecting page scroll)
        function scrollToSlide(index, behavior) {
            var slide = slides[index];
            var scrollPos = slide.offsetLeft - (scrollContainer.clientWidth - slide.offsetWidth) / 2;
            scrollContainer.scrollTo({ left: scrollPos, behavior: behavior });
        }

        // Scroll listener for dot/snapped updates (debounced)
        var scrollTimeout;
        scrollContainer.addEventListener('scroll', function() {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(function() {
                var newIndex = findCenteredSlide();
                if (newIndex !== currentIndex) {
                    currentIndex = newIndex;
                    updateDots();
                    updateSnapped();
                }
            }, 50);
        });

        if (prevBtn) {
            prevBtn.addEventListener('click', prevSlide);
        }

        if (nextBtn) {
            nextBtn.addEventListener('click', nextSlide);
        }

        dots.forEach(function(dot) {
            dot.addEventListener('click', function() {
                var slideIndex = parseInt(dot.dataset.carouselDot, 10) - 1;
                goToSlide(slideIndex);
            });
        });

        // Keyboard navigation when carousel is focused
        carousel.setAttribute('tabindex', '0');
        carousel.addEventListener('keydown', function(e) {
            if (e.key === 'ArrowLeft') {
                prevSlide();
                e.preventDefault();
            } else if (e.key === 'ArrowRight') {
                nextSlide();
                e.preventDefault();
            }
        });

        // Center first slide, set snapped state, then activate fade effect
        scrollToSlide(0, 'auto');
        updateSnapped();
        carousel.classList.add('carousel-ready');
        requestAnimationFrame(function() {
            carousel.classList.add('carousel-animated');
        });
    }

    function initAllCarousels() {
        var carousels = document.querySelectorAll('[data-carousel]');
        carousels.forEach(initCarousel);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAllCarousels);
    } else {
        initAllCarousels();
    }
})();
